import React from "react";
import { Icon } from "./../styles";

export const SuccessIcon = () => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.01392 49.9954C8.01392 27.1796 26.7714 8.61914 49.8258 8.61914C72.8802 8.61914 91.6376 27.1796 91.6376 49.9954C91.6376 72.8113 72.8802 91.3718 49.8258 91.3718C26.7714 91.3718 8.01392 72.8113 8.01392 49.9954ZM11.1498 49.9954C11.1498 71.0983 28.5008 88.2685 49.8258 88.2685C71.1507 88.2685 88.5017 71.0983 88.5017 49.9954C88.5017 28.8926 71.1507 11.7224 49.8258 11.7224C28.5008 11.7224 11.1498 28.8926 11.1498 49.9954ZM70.6826 36.3659C69.8656 35.5472 68.5326 35.539 67.7053 36.3475L44.9052 58.6282L33.9907 48.4807L33.8531 48.3632C33.0046 47.6994 31.7691 47.7781 31.0149 48.5726C30.2188 49.4111 30.2603 50.7296 31.1077 51.5174L43.5008 63.0397L43.6425 63.1603C44.4677 63.8026 45.6609 63.7471 46.4217 63.0036L70.664 39.3121L70.7878 39.1804C71.4898 38.3662 71.4566 37.1415 70.6826 36.3659Z"
        fill="#40C440"
      />
    </Icon>
  );
};
